import * as R from "ramda";
import { isRunningInBrowser } from "../ssr";
import { getUrlParamValue } from "./url";

const allowShowLogFlag = "GuVt6RWCwDw5FMbB";

export const allowShowLog = () => {
    const url = isRunningInBrowser() ? window.location.href : null;
    return !R.isNil(getUrlParamValue(url, allowShowLogFlag));
}